var _excluded = ["presets", "className", "onPresetItemClick", "onPresetItemMouseEnter", "onPresetItemMouseLeave"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useRefCallback } from '@okee-uikit/react-hooks';
import { classnames, isArray } from '@okee-uikit/react-utils';
import { usePrefixCls } from '@okee-uikit/react-config';
import { Link } from '../../../components/link';
export function DatePreset(props) {
  var presets = props.presets,
      className = props.className,
      onPresetItemClick = props.onPresetItemClick,
      onPresetItemMouseEnter = props.onPresetItemMouseEnter,
      onPresetItemMouseLeave = props.onPresetItemMouseLeave,
      extra = _objectWithoutProperties(props, _excluded);

  var cls = classnames(usePrefixCls('date-panel-preset'), className);
  var itemCls = usePrefixCls('date-panel-preset-item');
  var onPresetItemClickCallback = useRefCallback(onPresetItemClick);
  var onPresetItemMouseEnterCallback = useRefCallback(onPresetItemMouseEnter);
  var onPresetItemMouseLeaveCallback = useRefCallback(onPresetItemMouseLeave);

  if (!presets.length) {
    return null;
  }

  return React.createElement("div", _objectSpread(_objectSpread({}, extra), {}, {
    className: cls
  }), presets.map(function (item) {
    return React.createElement("div", {
      className: itemCls,
      key: item.key
    }, React.createElement(Link, {
      size: 'sm',
      onClick: function onClick() {
        return onPresetItemClickCallback(item);
      },
      onMouseEnter: function onMouseEnter() {
        return onPresetItemMouseEnterCallback(item);
      },
      onMouseLeave: function onMouseLeave() {
        return onPresetItemMouseLeaveCallback(item);
      }
    }, item.label));
  }));
}
export function isInnerPresets(presets) {
  var _a;

  var result = presets && isArray(presets) && ((_a = presets[0]) === null || _a === void 0 ? void 0 : _a.label) !== undefined;
  return !!result;
}